
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  SearchContactsParameters.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SearchContactsParameters.ts

export class SearchContactsParameters {

  // string SearchMask
  public SearchMask?: string=null;

  // int[] Profils
  public Profils: number[]=[];

  // bool SupplierContact
  public SupplierContact: boolean=false;
}